import { useEffect, useState } from 'react';
import { isRoyaleAdmin } from '../services/auth/royaleAdmin';

/**
 * true once the server confirms this session is an admin account (Mark's
 * Invite gate); false until then and for everyone else.
 */
const useIsRoyaleAdmin = () => {
  const [admin, setAdmin] = useState(false);
  useEffect(() => {
    let live = true;
    isRoyaleAdmin().then((yes) => {
      if (live) setAdmin(yes);
    });
    return () => {
      live = false;
    };
  }, []);
  return admin;
};

export default useIsRoyaleAdmin;
